<!--
 * @Copyright: 网易集成平台
 * @Author: xiaowenwen
 * @Date: 2021-12-17 09:57:14
 * @LastEditTime: 2022-04-27 15:22:47
 * @Description: 用户登录日志
-->
<template>
  <general-layout>
    <template #header>
      <east-operate>
        <template #left>
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(multipleSelection)"
            icon="el-icon-delete"
            >删除</el-button
          >
        </template>
        <template #right>
          <el-date-picker
            v-model="time"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            @change="fetchData"
            size="mini"
          >
          </el-date-picker>
          <el-select
            v-model="search.state"
            @change="fetchData"
            size="mini"
            style="width: 104px;margin-left:7px;"
          >
            <el-option value="" label="所有结果"></el-option>
            <el-option value="true" label="成功"></el-option>
            <el-option value="false" label="失败"></el-option>
          </el-select>
          <el-input
            placeholder="请输入标识(邮箱)关键字"
            size="mini"
            v-model="search.keyword"
            @keyup.enter.native="fetchData"
            clearable
          >
            <el-button
              type="primary"
              icon="el-icon-search"
              size="mini"
              title="搜索日志"
              @click="fetchData"
              slot="append"
            ></el-button>
          </el-input>
        </template>
      </east-operate>
    </template>
    <el-table
      :data="tableData.list"
      :empty-text="emptyText"
      @selection-change="handleSelectionChange"
      v-loading="loading"
    >
      <el-table-column
        type="selection"
        width="50"
        align="center"
        fixed="left"
      ></el-table-column>
      <el-table-column
        prop="account"
        label="邮箱"
        width="240"
      ></el-table-column>
      <el-table-column prop="operation" label="结果" width="240">
        <template slot-scope="scope">
          <span v-if="scope.row.operation === 'input.password.accountError'"
            >帐号或密码错误，请重新输入</span
          >
          <span
            v-else-if="scope.row.operation === 'input.password.strengthError'"
            >密码强度不足，请先修改密码</span
          >
          <span
            v-else-if="scope.row.operation === 'input.password.accountNotExist'"
            >账号不存在</span
          >
          <span v-else-if="scope.row.operation === 'input.password.illegal'"
            >非法操作</span
          >
          <span
            v-else-if="scope.row.operation === 'input.password.mobileNotExist'"
            >手机号不存在</span
          >
          <span
            v-else-if="scope.row.operation === 'input.password.mobileNotAllow'"
            >未开通手机重置密码</span
          >
          <span
            v-else-if="scope.row.operation === 'input.password.mobileIncorrect'"
            >手机号错误</span
          ><span
            v-else-if="scope.row.operation === 'input.password.serverError'"
            >服务器错误</span
          >
          <span
            v-else-if="scope.row.operation === 'input.password.noAccountName'"
            >密码不能包含邮箱账号</span
          >
          <span
            v-else-if="
              scope.row.operation === 'input.password.noConsecutiveAndIdentical'
            "
            >连续3位及以上的字符不能连续或相同</span
          >
          <span
            v-else-if="
              scope.row.operation === 'input.password.serverError.CPLDAP'
            "
            >AD密码修改失败,请检查AD密码规则,权限,或账号状态</span
          >
          <span
            v-else-if="
              scope.row.operation === 'input.password.serverError.CPWY'
            "
            >邮箱密码修改失败,请检查邮箱端密码规则</span
          >
          <span v-else-if="scope.row.operation === 'input.mobileSend.Error'"
            >短信发送失败, 请联系管理员</span
          >
          <span v-else-if="scope.row.operation === 'forced_password_change'"
            >用户密码在第一次登录之前必须修改,
            请点击【修改密码】进行密码修改</span
          >
          <span v-else>{{ scope.row.operation }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="类型" width="100"></el-table-column>
      <el-table-column label="操作时间" width="180" align="center">
        <template slot-scope="scope">
          {{ scope.row.addTime | dateFormat }}
        </template>
      </el-table-column>
      <el-table-column
        prop="url"
        label="请求接口"
        min-width="200"
      ></el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        width="250"
        :show-overflow-tooltip="true"
      >
        <!--  <template slot-scope="scope">
          <el-button type="text" @click="handleView(scope.$index, scope.row)">
            {{ scope.row.remark }}
          </el-button>
        </template> -->
      </el-table-column>
      <el-table-column prop="state" label="状态" width="80" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="handleView(scope.$index, scope.row)">
            <span v-if="scope.row.state" class="text-success">成功</span>
            <span v-else class="text-danger">失败</span>
          </el-button>
        </template></el-table-column
      >
      <el-table-column prop="ip" label="操作IP" width="160"></el-table-column>

      <el-table-column label="操作" width="150" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            @click="handleView(scope.$index, scope.row)"
            >明细</el-button
          >
          <el-button size="mini" type="text" @click="handleDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <template #footer>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="search.page"
        :page-sizes="$page.sizes"
        :page-size="search.size"
        layout="total, sizes, prev, pager, next"
        :total="tableData.total"
      >
      </el-pagination>
    </template>
    <!-- 明细 开始 -->
    <el-dialog
      custom-class="custom-dialog"
      title="日志明细"
      :visible.sync="viewShow"
    >
      <div class="dialog-main-box">
        <table>
          <tr>
            <td>邮箱账号：</td>
            <td>
              {{ viewData.account }} [{{ viewData.addTime | dateFormat }}]
            </td>
          </tr>
          <tr>
            <td>登陆状态：</td>
            <td>
              <span v-if="viewData.state" class="text-success">成功</span>
              <span v-else class="text-danger">失败</span>
            </td>
          </tr>
          <tr>
            <td>操作结果：</td>
            <td>{{ viewData.operation }}</td>
          </tr>
          <tr>
            <td>备注内容：</td>
            <td>
              <span class="text-danger">{{ viewData.remark }}</span>
            </td>
          </tr>
          <tr>
            <td>操作IP：</td>
            <td>{{ viewData.ip }}</td>
          </tr>
          <tr>
            <td>请求接口：</td>
            <td>{{ viewData.url }}</td>
          </tr>
          <tr>
            <td>请求来源：</td>
            <td>{{ viewData.referrer }}</td>
          </tr>
          <tr>
            <td>请求方式：</td>
            <td>{{ viewData.method }}</td>
          </tr>
          <!--  <tr>
            <td>请求参数：</td>
            <td>
              {{ viewData.data }}
            </td>
          </tr> -->
          <tr>
            <td>终端信息：</td>
            <td>
              {{ viewData.agent }}
            </td>
          </tr>
        </table>
      </div>
    </el-dialog>
    <!-- 明细 结束 -->
  </general-layout>
</template>
<script>
import LOG from "@/api/userbehavior";
import _ from "lodash";
export default {
  data() {
    return {
      search: {
        keyword: "",
        stime: "",
        etime: "",
        state: "",
        size: this.$page.size,
        page: 1
      },
      time: ["", ""],
      tableData: {},
      emptyText: "暂无数据! ",
      multipleSelection: [],
      viewShow: false,
      viewData: {},
      loading: true
    };
  },
  computed: {
    // ...mapState(['user'])
  },
  created() {
    // 组件创建完后获取数据，
    // 此时 data 已经被 observed 了
    this.fetchData();
  },
  watch: {
    // 如果路由有变化，会再次执行该方法
    $route: "fetchData"
  },
  methods: {
    measure() {
      this.tableHeight = window.innerHeight - 185;
    },
    async fetchData() {
      if (this.time === null) {
        this.time = ["", ""];
      }
      this.search.stime = this.time[0] || "";
      this.search.etime = this.time[1] || "";

      let response = await LOG.LIST(this.search);
      if (response.data.state) {
        if (this.search.page === 1 || response.data.logs.list.length) {
          this.tableData = response.data.logs;
          this.loading = false;
        } else {
          this.search.page = 1;
          await this.fetchData();
        }
      }
    },
    handleSizeChange(val) {
      this.search.size = val;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.search.page = val;
      this.fetchData();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    async handleDelete(logs) {
      logs = _.isArray(logs) ? logs : [logs];
      if (logs.length === 0) {
        this.$notify.warning({
          title: "提示",
          message: "请选择要删除的日志",
          duration: 1500
        });
      } else {
        try {
          await this.$confirm("删除不可恢复,确认?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            lockScroll: false
          });
          let ids = logs.map(l => l.id);
          let response = await LOG.DELETE({ ids });
          if (response.data.state) {
            this.$message.success("日志删除成功");
            await this.fetchData();
          } else {
            this.$message.error(response.data.message);
          }
          // eslint-disable-next-line no-empty
        } catch {}
      }
    },
    handleView(index, row) {
      this.viewData = row;
      this.viewShow = true;
    }
  }
};
</script>
<style lang="less" scoped>
.el-input {
  width: 200px;
  margin: 0 8px;
}
.custom-dialog {
  table {
    width: 100%;
    tr {
      line-height: 36px;
      td:first-child {
        width: 70px;
      }
    }
  }
}
</style>
